import { UIText2 } from '@cian/ui-kit';
import { ArrowUpS16, ArrowDownS16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as style from './Shutter.css';

export interface IShutterProps {
  maxHeight: number;
  children: React.ReactNode;
}

const getDefaultToggles = () => {
  return {
    open: (
      <>
        <UIText2 color="primary_100">Свернуть&nbsp;&nbsp;</UIText2>
        <ArrowUpS16 color="primary_100" />
      </>
    ),
    close: (
      <>
        <UIText2 color="primary_100">Читать полностью&nbsp;&nbsp;</UIText2>
        <ArrowDownS16 color="primary_100" />
      </>
    ),
  };
};

export function Shutter(props: IShutterProps) {
  const ref = React.createRef<HTMLDivElement>();
  const [open, setOpen] = React.useState(false);
  const [height, setHeightState] = React.useState(0);

  const { children, maxHeight } = props;
  const isOverHeight = height > maxHeight;

  const setHeight = () => {
    const elem = ref.current;
    /* istanbul ignore next */
    if (!elem) {
      return;
    }

    const { height } = elem.getBoundingClientRect();

    setHeightState(height);
  };

  const handleChange = () => {
    setOpen(!open);
  };

  const getToggleElement = (opened: boolean) => {
    const defaulToggles = getDefaultToggles();

    return opened ? defaulToggles.open : defaulToggles.close;
  };

  React.useEffect(() => {
    setHeight();
    window.addEventListener('resize', setHeight, false);

    return () => {
      window.removeEventListener('resize', setHeight, false);
    };
  }, [maxHeight]);

  return (
    <div data-mark="Shutter" className={style['container']}>
      <div className={style['content']} style={{ maxHeight: open ? `${height}px` : `${maxHeight}px` }}>
        <div className={style['layout']} data-id="content" ref={ref}>
          {children}
        </div>
      </div>
      {isOverHeight ? (
        <span className={style['toggle']} onClick={handleChange} data-id="toggle" data-mark="ShutterToggle">
          {getToggleElement(open)}
        </span>
      ) : null}
    </div>
  );
}
